var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { get, snakeCase } from 'lodash';
import toast from 'react-hot-toast';
import recursiveMapKeys from '../utils/recursiveMapKeys';
export function createApiClient(authenticationManager, baseURL, headers) {
    const apiClient = axios.create({
        baseURL,
        headers,
    });
    apiClient.interceptors.request.use(function (config) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            // Add params
            if (get(config, 'data')) {
                config.data = recursiveMapKeys(config.data, (k) => snakeCase(k));
            }
            if (get(config, 'params')) {
                config.params = recursiveMapKeys(config.params, (k) => snakeCase(k));
            }
            const userSession = yield authenticationManager.currentSession();
            const idToken = (_a = userSession === null || userSession === void 0 ? void 0 : userSession.getIdToken()) === null || _a === void 0 ? void 0 : _a.getJwtToken();
            if (idToken) {
                if (!config.headers) {
                    config.headers = {};
                }
                config.headers.Authorization = `Bearer ${idToken}`;
            }
            return config;
        });
    });
    // Handle responses
    apiClient.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // if error is 500 or above, show toast
        if (get(error, 'response.status') >= 500) {
            toast.error(get(error, 'message', 'Something went wrong'));
        }
        return Promise.reject(error);
    });
    return apiClient;
}
//# sourceMappingURL=createApiClient.js.map